import { decodeJwt } from '@/shared/utils/decodeJwt.ts';
import * as Sentry from '@sentry/react';
import { MarketCode, MarketCodeSchema } from '@schuettflix/utils';

export const getMarketsFromToken = (token: string): MarketCode[] => {
    try {
        const payload = decodeJwt(token);

        // OAuth-issued tokens (one user = one market): the operating market is a single claim.
        if (typeof payload.market === 'string') {
            const result = MarketCodeSchema.safeParse(payload.market);
            return result.success ? [result.data] : [];
        }

        // Okta-issued tokens: markets are derived from the `platform-admin-<market>` group names.
        if (Array.isArray(payload.groups)) {
            const invalidMarketCodes: string[] = [];

            const marketCodes = (payload.groups as string[])
                // NOTE: individual group names look like: "platform-admin-de"
                .filter(labelWithUnsafeFormat => /.*-[a-z]{2}$/i.test(labelWithUnsafeFormat))
                .map(labelWithSafeFormat => labelWithSafeFormat.split('-').pop()!)
                .map(rawMarketCode => rawMarketCode.toUpperCase())
                .filter(unsafeMarketCode => {
                    const result = MarketCodeSchema.safeParse(unsafeMarketCode);
                    if (!result.success) {
                        invalidMarketCodes.push(unsafeMarketCode);
                    }
                    return result.success;
                })
                .map(marketCodeAsString => marketCodeAsString as MarketCode);

            if (invalidMarketCodes.length > 0) {
                Sentry.captureException(`Invalid market codes detected in ID Token: ${invalidMarketCodes.join(', ')}`);
            }

            return marketCodes;
        }
    } catch {
        return [];
    }

    return [];
};
